import { ICardContractProgram } from "./types"
import css from './ui.module.scss'

import { SelectDate } from "@primitive/calendar"
import { getInputButton } from "@primitive/getInputButton"

import { Flex, Modal, Loader, Input, Divider, Button, Container, Toogle, ToolTip } from "@ui/index"
import { IconClearClose } from "@img/icons"
import { DictSelectorContainer } from "@smart/dictSelector/ui.container"
import CommonService from "@services/common.service"


/** Окно добавления или редактирования программы по договору */
export const CardContractProgram = ({
    loadingTitle, dbName, isOpen, cardMode, isLoadingCard, fieldsError,
    txtCourseNameID, txtCourseName, txtProgramTypeID, txtProgramType, txtDurationEducation, 
    txtVolumeHours, txtSumm, txtEducationDateStart, txtEducationDateEnd,
    txtSphere, txtQualification, txtRequirementName,
    
    dictSelectorData, txtEducationDateStartOnChange, 
    txtDurationEducationOnChange, handleBtnSave, handlerButtonCancel
}: ICardContractProgram) => {
    const programSum = Number(txtSumm.value)
    const fullPaymentSum = txtSumm.value === '' || !Number.isFinite(programSum)
        ? ''
        : CommonService.fullPaymentDiscount(Math.round(programSum)).discountedSum

    return <>
        <Modal isOpen={isOpen} isEsc maxWidth="640px" onCancel={handlerButtonCancel}>
            <Flex className={`modal_container ${css.dialog}`} width="100%">
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className={`modal_container-header ${css.header}`}>
                    <h4>{cardMode === 'new' ? 'Добавление программы' : 'Редактирование программы'}</h4>

                    <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Container className={css.content}>
                    <Flex gap="10px" className='modal_container-content'>
                        <Flex gap="5px">
                            <Divider gap="6px" prefix={<h4>Основные данные</h4>} 
                                suffix={
                                    <ToolTip placement="bottomRight" title={Number(txtProgramTypeID.value) === 3 ? 'Выкл. Свидетельство' : 'Вкл. Свидетельство'}>
                                        <Toogle checked={Number(txtProgramTypeID.value) === 3} onChange={
                                            txtProgramTypeID.value === 3 
                                                ? () => {
                                                    if (Number(txtVolumeHours.value) >= 250) {
                                                        txtProgramTypeID.setValue(1)
                                                        txtProgramType.setValue('Профессиональная переподготовка')
                                                    } else {
                                                        txtProgramTypeID.setValue(2)
                                                        txtProgramType.setValue('Повышение квалификации')
                                                    }
                                                }
                                                : () => {
                                                    txtProgramTypeID.setValue(3)
                                                    txtProgramType.setValue('Свидетельство')
                                                }
                                        } />    
                                    </ToolTip>
                                } 
                            />

                            <Flex gap='10px'>
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.courseName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Наименование курса <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Наименование курса" {...txtCourseName}
                                            suffix={
                                                <DictSelectorContainer dbName={dbName} dictName="coursesContract" 
                                                    onSelect={(data) => {dictSelectorData('coursesContract', data)}}
                                                >{getInputButton('select')}</DictSelectorContainer>
                                            }  
                                        />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.programType ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип программы <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Тип программы" isReadOnly paddingRight='4px' {...txtProgramType}
                                            suffix={
                                                <DictSelectorContainer isSearch={false} dbName={dbName} 
                                                    dictName="contractProgramInfo" whereParam1={txtCourseNameID.value?.toString()}
                                                    onSelect={(data) => {dictSelectorData('contractProgramInfo', data)}}
                                                >{getInputButton('select')}</DictSelectorContainer>
                                            }  
                                        />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.durationEducation ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Продолжительность <p className="pulse"></p></Flex>
                                        <Input placeholder="Продолжительность" paddingRight='4px' isReadOnly
                                            value={txtDurationEducation.value} onChange={(e) => txtDurationEducationOnChange(e.target.value)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.volumeHours ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Объём <p className="pulse"></p></Flex>
                                        <Input placeholder="Объём" paddingRight='4px' isReadOnly {...txtVolumeHours} />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='190px' isRendered={Number(txtProgramTypeID.value) !== 1} className={!fieldsError.value.summ ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Сумма <p className="pulse"></p></Flex>
                                        <Input placeholder="Сумма" paddingRight='4px' {...txtSumm} />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap" isRendered={Number(txtProgramTypeID.value) === 1}>
                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.summ ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Сумма <p className="pulse"></p></Flex>
                                        <Input placeholder="Сумма" paddingRight='4px' {...txtSumm} />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='190px'>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Сумма при полной оплате</Flex>
                                        <Input placeholder="Сумма при полной оплате" paddingRight='4px' isReadOnly value={fullPaymentSum} />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.educationDateStart ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Начало обучения <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Начало обучения" type='mask' mask='99.99.2099'
                                            value={txtEducationDateStart.value} onChange={(e) => txtEducationDateStartOnChange(e.target.value)}
                                            suffix={
                                                <SelectDate currentDate={txtEducationDateStart.value} onSelect={(date) => { txtEducationDateStartOnChange(date) }}>
                                                    {getInputButton('calendar')}
                                                </SelectDate>
                                            }
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='200px' className={!fieldsError.value.educationDateEnd ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Конец обучения <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Конец обучения" type='mask' mask='99.99.2099'
                                            value={txtEducationDateEnd.value} onChange={(e) => txtEducationDateEnd.setValue(e.target.value)}
                                            suffix={
                                                <SelectDate currentDate={txtEducationDateEnd.value} onSelect={(date) => { txtEducationDateEnd.setValue(date) }}>
                                                    {getInputButton('calendar')}
                                                </SelectDate>
                                            }
                                        />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>

                        {/* <Flex gap="5px">
                            <Divider prefix={<h4>Справочная информация</h4>} />

                            <Table.Content isScrollVertical={false}>
                                <Loader isOpen={isLoadingDict} color='#f34e2e' title='Загрузка информации...' backdrop />

                                {!courseProgramList.value.length 
                                    ? 'Информация отсутствуют'
                                    : courseProgramList.value.map((item, index) => (
                                        <Table.Row key={item.courseProgramID} onClick={() => handleClickProgramList(item.courseProgramID, item.durationEducation, item.volumeHours, item.sum, item.programID, item.programName)}>
                                            <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                <p>{item.programID === 1 ? 'Диплом' : 'Удостоверение'} - {item.programName}</p>
                                                <p style={{ opacity: '.8' }}>{CommonService.formatDuration(Number(item.durationEducation), item.programID === 2)} 👉 {CommonService.formatHours(Number(item.volumeHours))} 👉 {Number(item.sum)} ₽</p>
                                            </div>
                                        </Table.Row>
                                    ))
                                }
                            </Table.Content>
                        </Flex> */}

                        <Flex gap="5px">
                            <Divider gap="6px" prefix={<h4>Прочее</h4>} />

                            <Flex gap='10px'>
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.sphere ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Сфера <p className="pulse"></p></Flex>
                                        <Input placeholder="Сфера" paddingRight='4px' {...txtSphere} />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.qualification ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Квалификация <p className="pulse"></p></Flex>
                                        <Input placeholder="Квалификация" paddingRight='4px' {...txtQualification} />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap" isRendered={false}>
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.requirementName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Требование к образованию <p className="pulse"></p></Flex>
                                        <Input placeholder="Требование к образованию" isReadOnly paddingRight='4px' {...txtRequirementName} />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>

                        <Button width='100%' onClick={handleBtnSave}>
                            {cardMode === 'new' ? 'Добавить программу' : 'Применить изменения'}
                        </Button>
                    </Flex>

                    <Loader isOpen={isLoadingCard} title={loadingTitle.value} backdrop />
                </Container>
            </Flex>
        </Modal>
    </>
}